import { render, staticRenderFns } from "./taxInvoiceDetail.vue?vue&type=template&id=389b5310&scoped=true"
import script from "./taxInvoiceDetail.vue?vue&type=script&lang=js"
export * from "./taxInvoiceDetail.vue?vue&type=script&lang=js"
import style0 from "./taxInvoiceDetail.vue?vue&type=style&index=0&id=389b5310&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389b5310",
  null
  
)

export default component.exports